import { render } from "./PurchaseDetailsReport.vue?vue&type=template&id=183488a9&scoped=true"
import script from "./PurchaseDetailsReport.vue?vue&type=script&lang=js"
export * from "./PurchaseDetailsReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=183488a9&scoped=true&lang=css&external"
import "./PurchaseDetailsReport.vue?vue&type=style&index=1&id=183488a9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183488a9"]])

export default __exports__